// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"299":"ac4db168","453":"ef6157e2","794":"dd0afdb6"}[chunkId] + ".chunk.js";
};